module.exports = __webpack_public_path__ + "img/wmdys_bg.630cd33a.png";